module.exports = __webpack_public_path__ + "static/media/manutencao-imovel.1ac6d950.webp";